import { makeStyles } from '@material-ui/core'
import backgroundImage from '../../assets/portal-pattern.svg'
import newCompany from '../../assets/portal-new-company.svg'
import existingCompany from '../../assets/portal-existing-company.svg'
import loanNextIcon from '../../assets/portal-loan-next.svg'
import connectAdf from '../../assets/portal-connect-adf.svg'
import adfNextIcon from '../../assets/portal-adf-next.svg'
import newCompanySeleced from '../../assets/portal-newcompany-selected.svg'

const usePortalStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    const maxImgHeight = 'calc(48vh - 50px)'
    return {
        root: { display: 'flex' },
        appbar: {
            maxWidth: '100%',
            boxShadow: 'none',
            backgroundColor: '#ffff !important',
            position: 'relative'
        },
        betaTag: {
            display: 'flex',
            padding: '2px 8px',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '157%' /* 21.98px */,
            letterSpacing: '0.1px',
            backgroundColor: 'var(--blueGrey-100, #CFD8DC)',
            color: 'var(--blueGrey-600, #546E7A)',
            borderRadius: '72px',
            fontFeatureSettings: "'clig' off, 'liga' off",
            '&.MuiChip-root': {
                margin: '8px 3px 8px 10px !important'
            }
        },
        titleContainer: {
            display: 'flex'
        },
        titleText: {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--16, 16px)',
            alignSelf: 'stretch',
            fontWeight: 500,
            fontfamily: ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: '0.15000000596046448px',
            textAlign: 'left'
        },
        toolbar: {
            alignitems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            height: '56px',
            padding: '16px 24px',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.15), 0px 1px 10px 0px rgba(0, 0, 0, 0.15), 0px 2px 4px 0px rgba(0, 0, 0, 0.15)'
        },
        typography: {
            fontWeight: 500,
            fontFamily: ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: '0.15000000596046448px',
            textAlign: 'left'
        },
        logoImage: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '6px'
        },
        logoutImg: {
            height: '24px',
            width: '24px'
        },
        verticalRow: {
            height: '12px',
            width: '1px',
            background: 'var(--neutrals-grey-300, #E0E0E0)'
        },
        typography2: {
            fontWeight: 500
        },
        typography3: {
            fontweight: 100
        },
        rightSection: {
            display: 'flex',
            alignItems: 'center',
            gap: '24px'
        },
        logoutSection: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'flex-end'
        },
        logoutBtnText: {
            color: 'var(--primary-primary-500, #007DB8)',
            fontWeight: 500,
            fontFamily: 'Roboto',
            fontSize: '14px',
            lineHeight: '20px',
            fontStyle: 'normal'
        },
        bannerSection: {
            alignItems: 'baseline',
            display: 'flex',
            gap: '3px'
        },
        welcomeSection: {
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '20px',
            fontStyle: 'normal',
            color: 'var(--neutrals-grey-900, #212121)'
        },
        emailSection: {
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: 'var(--neutrals-grey-600, #757575)'
        },
        drawerContainer: {
            overflow: 'auto'
        },
        wrapper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        imageColumn: {
            display: 'flex',
            position: 'fixed',
            flexDirection: 'column',
            maxHeight: '900px',
            [mobileBreakpoint]: {
                display: 'none'
            }
        },
        mainContainer: {
            display: 'flex',
            width: '1440px',
            height: '1023px',
            padding: '56px 40px',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            flexShrink: 0,
            zIndex: 10
        },
        container: {
            maxWidth: '1280px',
            paddingBottom: '80px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '48px',
            height: 'calc(100vh - 56px)',
            alignSelf: 'stretch'
        },
        containerPattern: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            flexShrink: 0,
            width: '100%'
        },
        thankYouBox: {
            display: 'flex',
            maxWidth: '1264px',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            alignSelf: 'stretch'
        },
        thankYouBoxTitle: {
            alignSelf: 'stretch',
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '34px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '48px'
        },
        thankYouBoxDesc: {
            alignSelf: 'stretch',
            color: 'var(--neutrals-grey-900, #757575)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            lineHeight: '22px',
            fontWeight: 400
        },
        companyContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch'
        },
        companyHeaderContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            alignSelf: 'stretch'
        },
        companyHeaderTitle: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        companyHeaderDescription: {
            color: 'var(--neutrals-grey-600, #757575)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            alignSelf: 'stretch'
        },
        companyFramesContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch',
            flexWrap: 'wrap'
        },
        companyFrameSelected: {
            background: 'var(--primary-primary-100, #F3F9FB)  !important',
            boxShadow:
                '0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05)  !important',
            border: '2px solid var(--primary-primary-500, #007DB8) !important',
            cursor: 'auto !important'
        },
        existingCompanyFrameSelected: {
            border: '2px solid var(--primary-primary-500, #007DB8) !important',
            background: 'var(--primary-primary-100, #F3F9FB)  !important',
            boxShadow:
                '0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05)  !important',
            cursor: 'auto !important'
        },
        existingCompanyFrame: {
            display: 'flex',
            height: '140px',
            zIndex: 1,
            minWidth: '300px',
            maxWidth: '410px',
            padding: '24px',
            flexDirection: 'column',
            alignItems: ' flex-start',
            gap: '16px',
            flex: ' 1 0 0',
            borderRadius: '4px',
            cursor: 'pointer',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05)'
        },
        companyFrame: {
            display: 'flex',
            zIndex: 1,
            height: '140px',
            minWidth: '300px',
            maxWidth: '410px',
            padding: '24px',
            flexDirection: 'column',
            justifycontent: 'center',
            alignItems: 'center',
            gap: '8px',
            flex: '1 0 0',
            borderRadius: '4px',
            border: '1px dashed var(--neutrals-grey-500, #9E9E9E)',
            cursor: 'pointer'
        },
        existingCompany: {
            display: 'flex',
            width: '48px',
            height: '48px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            flexShrink: 0,
            borderRadius: '4px',
            background: 'var(--primary-primary-200, #E3F2F9)'
        },
        existingCompanyIcon: {
            width: '28px',
            height: '28px',
            flexShrink: 0,
            backgroundImage: `url(${existingCompany})`
        },
        companyTitle: {
            display: ' -webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': 1,
            alignSelf: 'stretch',
            overflow: 'hidden',
            color: 'var(--neutrals-grey-900, #212121)',
            textOverflow: 'ellipsis',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineheight: '28px'
        },
        newCompany: {
            width: '40px',
            height: '40px',
            flexShrink: 0
        },
        newCompanyIconSelected: {
            backgroundImage: `url(${newCompanySeleced}) !important`
        },
        newCompanyIcon: {
            width: '33.334px',
            height: '33.334px',
            flexShrink: 0,
            fill: 'var(--neutrals-grey-600, #757575)',
            backgroundImage: `url(${newCompany})`
        },
        newCompanyTitleSelected: {
            color: 'var(--neutrals-grey-900, #212121) !important'
        },
        newCompanyTitle: {
            display: ' -webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': 1,
            alignSelf: 'stretch',
            overflow: 'hidden',
            color: 'var(--neutrals-grey-600, #757575)',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontfamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        actionContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignself: 'stretch'
        },
        actionTitle: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        actionContentContainer: {
            display: 'flex',
            alignItems: ' flex-start',
            gap: '24px',
            alignSelf: 'stretch'
        },
        loanContainer: {
            display: 'flex',
            height: '236px',
            minWidth: '500px',
            maxWidth: '628px',
            padding: '24px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            flex: ' 1 0 0',
            borderRadius: '4px',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05)'
        },
        loanTopContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch'
        },
        loanIconContainer: {
            display: 'flex',
            width: '48px',
            height: '48px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '4px',
            background: 'var(--primary-primary-200, #E3F2F9)'
        },
        loanIcon: {
            width: '27.998px',
            height: '23.332px',
            flexShrink: 0,
            backgroundImage: `url(/assets/portal-loans-icon.png)`
        },
        loanContentContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            alignSelf: 'stretch'
        },
        loanTitle: {
            color: '#000',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        loanDescription: {
            alignSelf: 'stretch',
            color: 'var(--neutrals-grey-600, #757575)',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px'
        },
        loanStartButton: {
            display: 'flex',
            height: '42px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            borderRadius: '4px',
            background: 'var(--primary-primary-500, #007DB8)',
            cursor: 'pointer'
        },
        loanStartButtonText: {
            color: 'var(--neutrals-grey-00, #FFF)',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px'
        },
        loanStartButtonNextIcon: {
            display: 'flex',
            width: '24px',
            height: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: `url(${adfNextIcon}) !important`
        },
        loanButton: {
            display: 'flex',
            height: '42px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            borderRadius: '4px',
            border: '2px solid var(--primary-primary-500, #007DB8)',
            cursor: 'pointer'
        },
        loanButtonText: {
            color: 'var(--primary-primary-500, #007DB8)',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px'
        },
        loanButtonNextIcon: {
            display: 'flex',
            width: '24px',
            height: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: `url(${loanNextIcon}) !important`
        },
        adfContainer: {
            display: 'flex',
            height: '236px',
            minWidth: '500px',
            maxWidth: '628px',
            padding: '24px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            flex: ' 1 0 0',
            borderRadius: '4px',
            background: 'var(--neutrals-grey-00, #FFF)',
            boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.05)'
        },
        adfTopContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch'
        },
        adfContentContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            alignSelf: 'stretch'
        },
        adfTitle: {
            color: '#000',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px'
        },
        adfDescription: {
            alignSelf: 'stretch',
            color: 'var(--neutrals-grey-600, #757575)',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px'
        },
        adfIconContainer: {
            display: 'flex',
            width: '48px',
            height: '48px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '4px',
            background: 'var(--primary-primary-200, #E3F2F9)'
        },
        adfIcon: {
            width: '27.997px',
            height: '28.001px',
            flexShrink: 0,
            backgroundImage: `url(${connectAdf}) !important`
        },
        adfConnectedaButton: {
            display: 'flex',
            height: '42px',
            padding: '8px',
            justifyContent: 'left',
            alignItems: 'flex-start',
            gap: '17px',
            alignSelf: 'stretch',
            borderRadius: '4px',
            border: '1px solid var(--neutrals-grey-300, #E0E0E0)'
        },
        adfConnectedButtonText: {
            color: 'var(--neutrals-grey-00, #000)',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '25px'
        },
        adfButton: {
            display: 'flex',
            height: '42px',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            borderRadius: '4px',
            background: 'var(--primary-primary-500, #007DB8)',
            cursor: 'pointer'
        },
        adfButtonText: {
            color: 'var(--neutrals-grey-00, #FFF)',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px'
        },
        adfButtonNextIcon: {
            display: 'flex',
            width: '24px',
            height: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: `url(${adfNextIcon}) !important`
        },
        bannerComplete: {
            height: '1.375rem',
            fontSize: '1.125rem',
            position: 'relative',
            top: '-0.15rem'
        },
        dottedLine: {
            width: '1.4rem',
            height: '0rem',
            left: '1.438rem',
            top: '0px',
            border: '0.0125rem dotted #9E9E9E',
            transform: 'rotate(90deg)',
            marginTop: '0.125rem',
            marginBottom: '0.125rem'
        },
        applicationBox: {
            padding: '2.5rem',
            zIndex: 1,
            gap: '1.5rem',
            width: '28.063rem',
            background: '#FFFFFF',
            boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.15), 0px 1px 10px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.15)',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '900px',
            minWidth: '400px',
            [mobileBreakpoint]: {
                width: '100%',
                alignItems: 'vertical'
            }
        },
        bannerTitle: {
            fontFamily: 'var(--font-family-base)',
            fontSize: 'var(--logPage-header-text-size)',
            lineHeight: '68px',
            color: 'var(--black)',
            marginTop: '0rem',
            marginBottom: '0.5rem'
        },
        arrowIcon: {
            color: '#007DB8'
        },
        box: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '60vh',
            [mobileBreakpoint]: {
                flexDirection: 'column',
                minHeight: 'auto',
                padding: '24px 0'
            }
        },
        trapezoidBg: {
            position: 'relative',
            // minHeight: '80vh',
            overflow: 'hidden',
            // zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
            }
        },
        rootBg: {
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPositionY: 'bottom'
        },
        btnFlex: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        },
        Btn: {
            display: 'flex',
            height: '42px',
            width: '100%',
            padding: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            borderRadius: '4px'
        },
        applyDifferent: {
            border: ' 2px solid #007DB8'
        }
    }
})

export default usePortalStyles
